"use client";
import { Property } from "@/interfaces/property.interface";
import {
  getPlaceholdJPUrl,
  getTextColorForBackground,
} from "@/lib/agency-gradient";
import Image from "next/image";

export interface PropertyCaseHeaderProps {
  property: Property;
}

export const PropertyCaseHeader = (props: PropertyCaseHeaderProps) => {
  const { property } = props;
  const textColor = getTextColorForBackground(property.agency.color ?? "000");

  return (
    <div
      className="flex h-10 w-full items-center justify-center px-4 py-1 border-b rounded-t-xl"
      style={{
        background: property.agency.color,
      }}
    >
      <div className="relative h-full w-28">
        <Image
          fill
          src={
            property.agency?.logo ??
            getPlaceholdJPUrl(
              property.agency.name,
              property.agency.color,
              textColor,
              100
            )
          }
          className="object-contain"
          alt={property.agency?.name}
          sizes="10vw"
          priority
          fetchPriority="high"
        />
      </div>
    </div>
  );
};
